import { EMPLOYEE_ROUTE_NAME, STORE_ROUTE_NAME } from '@/libs/route-name';
import { profileRoute } from '@/pages/auth/route';
import type { RouteRecordRaw } from 'vue-router';

export const employeeRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  children: [
    {
      path: '',
      redirect: { name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES },
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'list-employee',
      name: EMPLOYEE_ROUTE_NAME.LIST_EMPLOYEE,
      component: () => import('@/pages/employee/index.vue'),
      meta: {
        requireAuth: true,
        requireStoreId: true,
      },
    },
    {
      path: 'pick-employees',
      name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES,
      component: () => import('@/pages/pick-employees/index.vue'),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'add-store',
      name: STORE_ROUTE_NAME.ADD_STORE,
      component: () => import('@/pages/store/add-store.vue'),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'store-settings',
      name: STORE_ROUTE_NAME.STORE_SETTINGS,
      component: () => import('@/pages/store/store-settings.vue'),
      meta: {
        requireAuth: true,
        requireStoreId: true,
      },
    },
    profileRoute()
  ],
};
